module.exports = __webpack_public_path__ + "img/icon3.8b1fa040.png";